import React, { useEffect, useState } from 'react'
import Chart from "react-apexcharts";

export default function LineChart(props) {
	const [seriesData, setSeriesData] = useState([]);
	
	useEffect( () => {
		switch (props.alignment) {
            case 'seven':
				setSeriesData(Object.values(props.chartResult).slice(-7));
              	break
            case 'fifteen':
				setSeriesData(Object.values(props.chartResult).slice(-15));
              	break
            case 'thirty':
				setSeriesData(Object.values(props.chartResult).slice(-30));
              	break
            default:
        }
	}, [props.chartResult, props.alignment])

	const chartData = {
		series: [{
			name: '신규사용자 ',
			data : seriesData.map(dataList => {
				return dataList;
			})
		}],
		options: {
			chart: {
				height: 350,
				type: 'line',
				zoom: {
				enabled: false
				},
				toolbar: {
					show: false
				},
			},
			dataLabels: {
				enabled: false
			},
			stroke: {
				curve: 'straight'
			},
			markers: {
				size: 5,
			},
			title: {
				// text: '일별 신규 사용자 수',
				align: 'center'
			},
			grid: {
				row: {
				colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
				opacity: 0.5
				},
			},
			xaxis: {
				// type: 'datetime',
				// labels: {
				// 	format: 'MMM-dd'
				// },
				// max: new Date().toLocaleDateString(),
			},
			yaxis: {
				labels: {
					formatter: function(val) {
						return val.toFixed(0);
					}
				},
				// tickAmount: 6,
				// min: 0,
			},
			tooltip: {
				y: {
					formatter: function (val) {
						return val + " 명"
					}
				}
			}
		},
	}

	return (
		<div id="chart">
			<Chart options={chartData.options} series={chartData.series} type="line" height={230} />
		</div>
	)
}
